export const environment = {
  production: true,

  companyCode: 'DCF01',
  getBusinessName: 'My Fortress Townsville',
  commonCompanyCode: 'DCF01',
  getBaseURL: 'https://api.townsville.staff.myfortress.com.au/api',
  getAuthURL: 'https://api.auth.myfortress.com.au/api',
  getPortalURL: 'https://clientportal.townsville.myfortress.com.au',
  getAuthDomain: '.myfortress.com.au',
};
